<template>
  <div style="height: 100vh; overflow: hidden">
    <!-- <div class="menu-title">
      <div class="menu-crew" @click="gotoHome">宁波海员管理后台</div>
      <div class="menu-user"> -->
    <!-- <div>{{ userName }}</div> -->
    <!-- </div>
    </div> -->
    <div class="el-menu-st">
      <div>
        <div class="menu-title">
          <div class="menu-crew" @click="gotoHome">宁波海员数字化管理平台</div>
        </div>
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          @select="selectMeau"
          background-color="#222944"
          text-color="#fff"
          style="height: 100%; width: 15rem"
        >
          <el-menu-item index="1">
            <i class="el-icon-s-check"></i>
            <span slot="title">备案信息</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-picture-outline"></i>
            <span slot="title">海员风采</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-video-camera"></i>
            <span slot="title">案例视频</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div v-show="activeMenu == '1'" class="menu-table">
        <!-- 首页对应的右侧内容区 -->
        <el-form :inline="true" :model="formInline" class="form-inline">
          <el-form-item style="margin-right: 2.1429rem">
            <el-button
              type="primary"
              size="medium"
              @click="onSubmit"
              class="marit-button"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formInline.beginDate"
              style="margin-right: 1rem"
            ></el-date-picker>
            <el-date-picker
              type="date"
              placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formInline.endDate"
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item>
            <el-select v-model="formInline.recordType" placeholder="申报状态">
              <el-option label="申报状态" value=""></el-option>
              <el-option
                label="船员服务业务基础信息备案表"
                value="1"
              ></el-option>
              <el-option
                label="船员服务业务开展情况年度备案表"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-input
              v-model="formInline.recordName"
              placeholder="请输入申报名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.companyName"
              placeholder="公司名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          style="width: 79.71rem; margin: 0 auto"
          class="table-mar"
        >
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="companyName" label="公司名称">
          </el-table-column>
          <el-table-column prop="recordName" label="申报名称" width="400">
          </el-table-column>
          <el-table-column prop="signatureDate" label="日期" width="240">
          </el-table-column>
          <!-- <el-table-column prop="recordState" label="申报状态">
            <template slot-scope="scope">
              {{ formatStatus(scope.row.recordState) }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="210">
            <template slot-scope="scope">
              <el-button size="mini" @click="watchList(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50]"
            :page-size="formInline.pageSize"
            :total="total"
            layout="prev, pager, next,sizes"
          ></el-pagination>
        </div>
      </div>
      <div v-show="activeMenu == '2'" class="menu-table">
        <el-form :inline="true" :model="formInline2" class="form-inline">
          <el-form-item style="margin-right: 2.1429rem">
            <el-button
              type="success"
              size="medium"
              @click="createPhoto"
              class="marit-button2"
              >添加照片</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              @click="onSubmit2"
              class="marit-button"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formInline2.beginDate"
              style="margin-right: 1rem"
            ></el-date-picker>
            <el-date-picker
              type="date"
              placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formInline2.endDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline2.mediaName"
              placeholder="请输入照片名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData2"
          border
          style="width: 79.71rem; margin: 0 auto"
          class="table-mar"
        >
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="mediaName" label="图片名称" width="300">
          </el-table-column>
          <el-table-column
            prop="mediaIntroduction"
            label="图片介绍"
            width="240"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column prop="uploadTime" label="上传日期">
          </el-table-column>
          <el-table-column prop="weights" label="权重(排序)"></el-table-column>
          <el-table-column label="操作" width="310">
            <template slot-scope="scope">
              <el-button size="mini" @click="watchPhoto(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="editPhoto(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.showMedia == 0"
                type="warning"
                @click="showUpPhoto(scope.row)"
                >上架</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.showMedia != 0"
                type="warning"
                @click="showUpPhoto2(scope.row)"
                >下架</el-button
              >
              <el-button size="mini" type="danger" @click="delPhoto(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :page-sizes="[10, 20, 50]"
            :page-size="formInline2.pageSize"
            :total="total2"
            layout="prev, pager, next,sizes"
          ></el-pagination>
        </div>
      </div>
      <div v-show="activeMenu == '3'" class="menu-table">
        <el-form :inline="true" :model="formInline3" class="form-inline">
          <el-form-item style="margin-right: 2.1429rem">
            <el-button
              type="success"
              size="medium"
              @click="createVideo"
              class="marit-button2"
              >添加视频</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              @click="onSubmit3"
              class="marit-button"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formInline3.beginDate"
              style="margin-right: 1rem"
            ></el-date-picker>
            <el-date-picker
              type="date"
              placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formInline3.endDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline3.mediaName"
              placeholder="请输入视频名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData3"
          border
          style="width: 79.71rem; margin: 0 auto"
          class="table-mar"
        >
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="mediaName" label="视频名称" width="300">
          </el-table-column>
          <el-table-column
            prop="mediaIntroduction"
            label="视频介绍"
            width="240"
          >
          </el-table-column>
          <el-table-column prop="uploadTime" label="上传日期">
          </el-table-column>
          <el-table-column prop="weights" label="权重(排序)"></el-table-column>
          <el-table-column label="操作" width="310">
            <template slot-scope="scope">
              <el-button size="mini" @click="watchVideo(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="editVideo(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.showMedia == 0"
                type="warning"
                @click="showUpVideo(scope.row)"
                >上架</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.showMedia != 0"
                type="warning"
                @click="showUpVideo2(scope.row)"
                >下架</el-button
              >
              <el-button size="mini" type="danger" @click="delVideo(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
            :page-sizes="[10, 20, 50]"
            :page-size="formInline3.pageSize"
            :total="total3"
            layout="prev, pager, next,sizes"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-color"
      width="100%"
      title="船员服务业务开展情况年度备案表"
      top="0"
      :visible.sync="innerVisible"
    >
      <div class="dialog-title">船员服务业务开展情况年度备案表</div>
      <div class="dialog-content">
        <div class="dialog-message" style="margin-bottom: 1rem">
          <div>基本信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label"> 单位名称 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.companyName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 经本单位管理上船工作的船员人数 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.manageCrewAmount"
              type="number"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 与本单位劳动合同船员总人数 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.laborCrewAmount"
              type="number"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 与本单位服务合同船员总人数 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.serviceCrewAmount"
              type="number"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              年度服务船员情况(代理船员办理申请
              培训、考试、申领证书及派遣船员情况)
            </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.crewYearSituation"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              船员培训情况<br />上船船员岗前培训覆盖率
            </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.crewTrainRate"
              type="number"
            ></el-input
            >%
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              《劳务派遣经营许可证》年度核验情况 (需及时补充报送年度核验结果)
            </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.yearVerification"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem 0">
          <div>船员信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <div style="width: 100%">
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; font-weight: 600; border: 0px"
          >
            <tr>
              <td rowspan="3" style="width: 15.71rem; padding: 0 1rem">
                上船船员任职资历情况
              </td>
              <td class="gray-td">在船1 - 4个月</td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.seniority1"
                  style="width: 95%"
                ></el-input
                >人
              </td>
            </tr>
            <tr>
              <td class="gray-td">在船4 - 8个月</td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.seniority2"
                  style="width: 95%"
                ></el-input
                >人
              </td>
            </tr>
            <tr>
              <td class="gray-td">在船8个月以上</td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.seniority3"
                  style="width: 95%"
                ></el-input
                >人
              </td>
            </tr>
          </table>
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; font-weight: 600; border: 0px"
          >
            <tr>
              <td rowspan="3" style="width: 15.71rem; padding: 0 1rem">
                船员在船安全记录情况
              </td>
              <td class="gray-td">安全生产事故</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.safetyRecordProduct"
                  label="0"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.safetyRecordProduct"
                  label="1"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.safetyRecordProductNum"
                  style="width: 80%"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">人身意外伤害</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.safetyRecordAccident"
                  label="0"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.safetyRecordAccident"
                  label="1"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.safetyRecordAccidentNum"
                  style="width: 80%"
                ></el-input
                ><span>件次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">因意外伤害导致死亡</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.safetyRecordDeath"
                  label="0"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.safetyRecordDeath"
                  label="1"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.safetyRecordDeathNum"
                  style="width: 80%"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
          </table>
          <table
            border="1"
            cellspacing="0"
            style="width: 100%; height: 100%; font-weight: 600; border: 0px"
          >
            <tr>
              <td rowspan="2" style="width: 15.71rem; padding: 0 1rem">
                船员在船健康状况
              </td>
              <td class="gray-td">因疾病导致需下船治疗</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.healthConditionDisease"
                  label="0"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.healthConditionDisease"
                  label="1"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.healthConditionDiseaseNum"
                  style="width: 80%"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">因疾病导致死亡</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.healthConditionDeath"
                  label="1"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.healthConditionDeath"
                  label="2"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.healthConditionDeathNum"
                  style="width: 80%"
                ></el-input
                ><span>人次</span>
              </td>
            </tr>
          </table>
          <table
            border="1"
            cellspacing="0"
            style="
              width: 100%;
              height: 100%;
              border: #cccccc;
              font-weight: 600;
              color: #333333;
            "
          >
            <tr>
              <td rowspan="2" style="width: 15.71rem; padding: 0 1rem"></td>
              <td class="gray-td">因船员服务业务接受行政处罚情况</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.administrativePenalties"
                  label="1"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.administrativePenalties"
                  label="2"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.administrativePenaltiesNum"
                  style="width: 80%"
                ></el-input
                ><span>次</span>
              </td>
            </tr>
            <tr>
              <td class="gray-td">因船员服务业务接受约谈、责令纠正情况</td>
              <td class="td-check" style="padding: 0 2rem">
                <el-radio
                  v-model="params.interviewCondition"
                  label="1"
                  disabled="true"
                  >无</el-radio
                >
                <el-radio
                  v-model="params.interviewCondition"
                  label="2"
                  disabled="true"
                  >有</el-radio
                >
              </td>
              <td class="flex-td">
                <el-input
                  disabled="true"
                  class="paperview-input-text"
                  v-model="params.interviewConditionNum"
                  style="width: 80%"
                ></el-input
                ><span>次</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="dialog-message" style="margin: 1rem">
          <div>法定代表人签字</div>
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS2"
          :label-style="LS2"
        >
          <el-descriptions-item>
            <template slot="label"> 法定代表人签字（盖章） </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="params.signatureName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 日 期 </template>
            <el-date-picker
              type="date"
              disabled="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="params.signatureDate"
            ></el-date-picker>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem">
          <div>
            备注:1.统计时间节点为上年度1月1日至12月31日。2.存在因船员服务业务接受行政处罚或因船员服务业务接受约谈、责令纠正情况
          </div>
        </div>
        <div class="dialog-message" style="margin: 1rem">
          <div>上传文件</div>
        </div>
        <el-upload
          class="upload-demo"
          action
          multiple
          :limit="1"
          :file-list="fileList"
          :on-preview="handlePreview"
          disabled
        >
          <el-button size="small" type="primary" v-if="false"
            >选择文件</el-button
          >
          <!-- <div slot="tip" class="el-upload__tip">
            注:请上传文件或者图片，支持pdf、docx、xls、xlsx、ceb等格式，最大限制30MB
          </div> -->
        </el-upload>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-color"
      width="100%"
      title="船员服务业务基础信息备案表"
      top="0"
      :visible.sync="baseVisible"
    >
      <div class="dialog-title">船员服务业务基础信息备案表</div>
      <div class="dialog-content">
        <div class="dialog-message" style="margin-bottom: 1rem">
          <div>基本信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label"> 单位名称 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.companyName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 统一社会信用代码 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.organizationCode"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位法人 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.legalPerson"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 联系电话 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.legalPersonPhone"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位负责人 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.inchargePerson"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 联系电话 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.inchargePhone"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位联系人 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.contactsName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 联系电话 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.contactsPhone"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 注册资金(元) </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.registeredCapital"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 实缴注册资金(元) </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.realPayCapical"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位性质 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.companyKind"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 是否含外资 </template>
            <el-radio
              v-model="baseParams.containForeignCapital"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.containForeignCapital"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 工商注册号 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.businessRegistrationNo"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 注册日期 </template>
            <el-date-picker
              type="date"
              disabled="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="params.registeredDate"
            ></el-date-picker>
            <!-- <el-input class="paperview-input-text" v-model="baseParams.registeredDate"></el-input> -->
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem 0">
          <div>其他信息</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label">
              单位英文名称(内河船员服务机构无须填写)
            </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.companyNameEn"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位实际地址 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.realAddress"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 单位注册地址 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.registerAddress"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证号码 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.licenseCode"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证有效期 </template>
            <el-date-picker
              type="date"
              disabled="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="baseParams.licenseValidityDate"
            ></el-date-picker>
            <!-- <el-input class="paperview-input-text" v-model="baseParams.licenseValidityDate"></el-input> -->
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证许可机关 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.licenseAuthority"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 是否从事海船船员服务业务 </template>
            <el-radio
              v-model="baseParams.seafaringCrewService"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.seafaringCrewService"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 其他资质信息 </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.otherQualificationInformation"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem 0">
          <div>附送材料列表(需上传原件)</div>
          <!-- <div><i class="el-icon-remove"></i>收起</div> -->
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS"
          :label-style="LS"
        >
          <el-descriptions-item>
            <template slot="label">
              证明具有独立法人资格的营业执照复印件
            </template>
            <el-radio
              v-model="baseParams.attachedMaterials1"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials1"
              label="1"
              disabled="true"
              >有</el-radio
            >
            <!-- <el-input class="paperview-input-text" v-model="baseParams.attachedMaterials1"></el-input> -->
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 劳务派遣经营许可证副本的复印件 </template>
            <el-radio
              v-model="baseParams.attachedMaterials2"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials2"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 公司船员服务管理制度 </template>
            <el-radio
              v-model="baseParams.attachedMaterials3"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials3"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              船员服务业务项目及收费标准(需加盖公章)
            </template>
            <el-radio
              v-model="baseParams.attachedMaterials4"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials4"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 公司法人身份证复印件 </template>
            <el-radio
              v-model="baseParams.attachedMaterials5"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials5"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 委托书(非法人办理时提供) </template>
            <el-radio
              v-model="baseParams.attachedMaterials6"
              label="0"
              disabled="true"
              >无</el-radio
            >
            <el-radio
              v-model="baseParams.attachedMaterials6"
              label="1"
              disabled="true"
              >有</el-radio
            >
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message-title" style="margin: 1rem 0">
          <div>
            登记信息接收机构（由企业填写所在辖区海事管理机构或地方交通运输主管部门名称）
          </div>
          <div>公司承诺</div>
        </div>
        <div class="input-textarea">
          <el-input
            disabled="true"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 3, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="baseParams.receiveDeptName"
          >
          </el-input>
          <el-input
            disabled="true"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 3, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="companyLogo"
          >
          </el-input>
        </div>
        <div class="dialog-message" style="margin: 1rem">
          <div>法定代表人签字</div>
        </div>
        <el-descriptions
          :column="2"
          :size="size"
          border
          :contentStyle="CS2"
          :label-style="LS2"
        >
          <el-descriptions-item>
            <template slot="label"> 法定代表人签字（盖章） </template>
            <el-input
              disabled="true"
              class="paperview-input-text"
              v-model="baseParams.signatureName"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 日 期 </template>
            <el-date-picker
              disabled="true"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="baseParams.signatureDate"
            ></el-date-picker>
          </el-descriptions-item>
        </el-descriptions>
        <div class="dialog-message" style="margin: 1rem">
          <div>上传文件</div>
        </div>
        <el-upload
          multiple
          :limit="1"
          :file-list="fileList"
          :on-preview="handlePreview"
          disabled="true"
        >
          <el-button size="small" type="primary" v-if="false"
            >选择文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            注:请上传文件或者图片，支持pdf、docx、xls、xlsx、ceb等格式，最大限制30MB
          </div>
        </el-upload>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-color"
      width="60.7143rem"
      title="添加照片"
      :visible.sync="photoVisible"
    >
      <el-form
        :model="formPhoto"
        :rules="rules"
        ref="formPhoto"
        label-width="80px"
      >
        <el-form-item label="图片名称" prop="mediaName">
          <el-input
            v-model="formPhoto.mediaName"
            :disabled="!photoUse"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片介绍" prop="mediaIntroduction">
          <el-input
            type="textarea"
            v-model="formPhoto.mediaIntroduction"
            :disabled="!photoUse"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片权重">
          <el-input
            v-model="formPhoto.weights"
            :disabled="!photoUse"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="url">
          <el-upload
            class="avatar-uploader"
            action
            :http-request="uploadFile"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :disabled="!photoUse"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              注: 支持jpg/gif/png格式,不超过20M
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="photoVisible = false">取 消</el-button>
        <el-button
          v-if="photoUse"
          type="primary"
          @click="submitPhoto"
          v-loading="loading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-color"
      width="60.7143rem"
      title="添加视频"
      :visible.sync="videoVisible"
    >
      <el-form ref="form" :model="formViedo" :rules="rules" label-width="80px">
        <el-form-item label="视频名称" prop="mediaName">
          <el-input
            v-model="formViedo.mediaName"
            :disabled="!viedoUser"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频介绍" prop="mediaIntroduction">
          <el-input
            type="textarea"
            v-model="formViedo.mediaIntroduction"
            :disabled="!viedoUser"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频权重">
          <el-input
            v-model="formViedo.weights"
            :disabled="!viedoUser"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传视频" prop="url">
          <el-upload
            class="upload-demo"
            action
            :http-request="uploadFile2"
            :before-upload="beforeUpload2"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="videoList"
            :disabled="!viedoUser"
          >
            <el-button size="small" type="primary" v-if="viedoUser"
              >选择文件</el-button
            >
            <div slot="tip" class="el-upload__tip">
              注: 单个上传文件最大100M,支持MP4/MP3
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="videoVisible = false">取 消</el-button>
        <el-button
          v-if="viedoUser"
          type="primary"
          @click="submitVideo"
          v-loading="loading2"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectRecordMsa,
  watchDetail,
  getOneFile,
  selecteMediaInfo,
  saveOrUpdateMedia,
  mediadetail,
  showMedia,
  deleteMedia,
} from "@/apis/index";
import { post } from "@/apis/axios";
import { apiRoot } from "@/config";
// const OSS = require('ali-oss');
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      userName: "",
      newsDetail: {},
      rules: {
        mediaName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        mediaIntroduction: [
          { required: true, message: "请输入介绍", trigger: "blur" },
        ],
        url: [{ required: true, message: "请上传", trigger: "blur" }],
      },
      // menuWidth: "15rem",
      activeMenu: "1",
      formInline: {
        pageSize: 10,
        pageNo: 1,
      },
      formInline2: {
        mediaType: "1",
        pageSize: 10,
        pageNo: 1,
      },
      formInline3: {
        mediaType: "2",
        pageSize: 10,
        pageNo: 1,
      },
      formPhoto: {},
      formViedo: {},
      innerVisible: false,
      baseVisible: false,
      photoVisible: false,
      photoUse: true,
      viedoUser: true,
      videoVisible: false,
      params: {},
      baseParams: {},
      tableData: [],
      fileList: [],
      total: 0,
      total2: 0,
      total3: 0,
      photoList: [],
      tableData2: [],
      tableData3: [],
      videoList: [],
      loading: false,
      loading2: false,
      size: "small", // 或者根据需要设置初始值
      companyLogo:
        "本公司承诺严格遵守船员业务办理相关规定，规范开展船员相关各项业务，维护船员合法 权益。发生发现违规行为及损害船员权益行为，自愿接受约谈、整改、处罚、信誉管理、权限撤销等处理措施",
      LS: {
        "text-align": "right",
        "font-weight": "600",
        height: "3rem",
        width: "20rem",
        "word-break": "keep-all",
        fontWeight: "600",
        color: "#333333",
      },
      CS: {
        display: "flex",
        width: "24.1429rem",
        "line-height": "2.8571rem",
        // height: "3rem",
      },
      LS2: {
        "text-align": "right",
        "font-weight": "600",
        height: "3rem",
        width: "20rem",
        "word-break": "keep-all",
        fontWeight: "600",
        color: "#333333",
      },
      CS2: {
        // height: "3rem",
        width: "24.1429rem",
        display: "flex",
        "line-height": "2.8571rem",
      },
      CS3: {
        height: "3rem",
        width: "24.1429rem",
        display: "flex",
        "line-height": "2.8571rem",
      },
      imageUrl: "",
      imageUrl2: "",
      fileType: [
        "avi",
        "wmv",
        "mpg",
        "mpeg",
        "mpe",
        "mov",
        "rm",
        "ram",
        "swf",
        "flv",
        "mp4",
        "3gp",
        "rmvb",
        "asf",
        "asx",
      ],
      filePhotoType: ["jpg", "gif", "png", "jpeg"],
      pictureUrl: "",
      viedoPic: "",
    };
  },
  mounted() {
    this.getUser();
    this.selectRecordList();
  },
  created() {},
  methods: {
    getUser() {
      this.userName = sessionStorage.getItem("loginName");
      let postName = sessionStorage.getItem("postName");
      if (postName) {
        this.userName = postName;
      }
    },
    //图片查看
    async watchPhoto(item) {
      let res = await mediadetail({ id: item.id });
      this.formPhoto = res.data;
      this.lookFileSrc(res.data.pictureUrl);
      this.photoVisible = true;
      this.photoUse = false;
    },
    async editPhoto(item) {
      let res = await mediadetail({ id: item.id });
      this.formPhoto = res.data;
      this.lookFileSrc(res.data.pictureUrl);
      this.photoVisible = true;
      this.photoUse = true;
    },
    //上架
    async upPhoto(item) {
      await showMedia({ id: item.id });
      // this.formPhoto = res.data;
      this.selecteMediaInfoList();
    },
    showUpPhoto(item) {
      this.$confirm("确定要上架吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "上架成功",
            type: "success",
          });
          this.upPhoto(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    showUpPhoto2(item) {
      this.$confirm("确定要下架吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "上架成功",
            type: "success",
          });
          this.upPhoto(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    //删除
    async delPhotos(item) {
      await deleteMedia({ id: item.id });
      this.selecteMediaInfoList();
    },
    //视频查看
    async watchVideo(item) {
      let res = await mediadetail({ id: item.id });
      this.formViedo = res.data;
      this.lookFileSrc(res.data.mediaUrl);
      this.videoVisible = true;
      this.viedoUser = false;
    },
    //编辑
    async editVideo(item) {
      let res = await mediadetail({ id: item.id });
      this.formViedo = res.data;
      this.lookFileSrc(res.data.mediaUrl);
      this.videoVisible = true;
      this.viedoUser = true;
    },
    //上架
    async upVideo(item) {
      await showMedia({ id: item.id });
      // this.formPhoto = res.data;
      this.selectViedoInfoList();
    },
    showUpVideo(item) {
      this.$confirm("确定要上架吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "上架成功",
            type: "success",
          });
          this.upVideo(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    showUpVideo2(item) {
      this.$confirm("确定要下架吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "上架成功",
            type: "success",
          });
          this.upVideo(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    //删除
    async delVideos(item) {
      await deleteMedia({ id: item.id });
      this.selectViedoInfoList();
    },
    delPhoto(item) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.delPhotos(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    delVideo(item) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.delVideos(item);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    //添加图片
    createPhoto() {
      this.formPhoto = {};
      this.imageUrl = "";
      this.photoVisible = true;
      this.photoUse = true;
    },
    //添加视频
    createVideo() {
      this.videoList = [];
      this.formViedo = {};
      this.viedoUser = true;
      this.videoVisible = true;
    },
    //查询申报
    onSubmit() {
      this.formInline.pageNo = 1;
      this.selectRecordList();
    },
    //查询图片
    onSubmit2() {
      this.formInline2.pageNo = 1;
      this.selecteMediaInfoList();
    },
    //查询视频
    onSubmit3() {
      this.formInline3.pageNo = 1;
      this.selectViedoInfoList();
    },
    //查看点击附件
    handlePreview(file) {
      console.log(file);
      window.open(file.url);
    },
    //提交图片
    async submitPhoto() {
      if (
        this.formPhoto.mediaName &&
        this.formPhoto.mediaIntroduction &&
        this.formPhoto.pictureUrl &&
        this.formPhoto.mediaUrl
      ) {
        this.formPhoto.mediaType = "1";
        this.viedoUser = true;
        await saveOrUpdateMedia(this.formPhoto);
        this.$message({
          message: "成功",
          type: "success",
        });
        this.photoVisible = false;
        this.selecteMediaInfoList();
      } else {
        this.$message.error("请填写必填项!");
      }
    },
    //提交视频
    async submitVideo() {
      console.log(this.formViedo);
      if (
        this.formViedo.mediaName &&
        this.formViedo.mediaIntroduction &&
        this.formViedo.pictureUrl &&
        this.formViedo.mediaUrl
      ) {
        this.formViedo.mediaType = "2";
        await saveOrUpdateMedia(this.formViedo);
        this.$message({
          message: "成功",
          type: "success",
        });
        this.videoVisible = false;
        this.selectViedoInfoList();
      } else {
        this.$message.error("请填写必填项!");
      }
    },
    //照片
    uploadFile(file) {
      this.loading = true;
      this.imageUrl = URL.createObjectURL(file.file);
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      // let obj = {
      //   fileName: file.name,
      //   fileSrc: "",
      //   data: fileData,
      // };
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          this.formPhoto.pictureUrl = res.data;
          this.formPhoto.mediaUrl = res.data;
          this.loading = false;
        })
        .catch(() => {});
    },
    //视频
    uploadFile2(file) {
      this.loading2 = true;
      // console.log(file);
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      // let obj = {
      //   fileName: file.name,
      //   fileSrc: "",
      //   data: fileData,
      // };
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          this.formViedo.mediaUrl = res.data;
          this.lookFileSrc2(this.formViedo.mediaUrl);
          this.loading2 = false;
        })
        .catch(() => {});
    },
    //查看申报详情
    async watchList(item) {
      // console.log(item);
      this.fileList = [];
      if (item.recordType == 2) {
        this.innerVisible = true;
        let res = await watchDetail({
          id: item.id,
          recordType: item.recordType,
        });
        // console.log(res.data.appendixUrl);
        this.lookFileSrc(res.data.appendixUrl);

        this.params = res.data;
      } else if (item.recordType == 1) {
        this.baseVisible = true;
        let res = await watchDetail({
          id: item.id,
          recordType: item.recordType,
        });
        // console.log(res.data.appendixUrl);
        this.lookFileSrc(res.data.appendixUrl);
        this.baseParams = res.data;
      }

      // console.log(res);
    },
    //截取第一帧
    getVideoImage(url) {
      var videoElement = document.createElement("video");
      videoElement.src = url;
      videoElement.setAttribute("crossOrigin", "anonymous");
      videoElement.preload = true;
      videoElement.autoplay = true;
      videoElement.muted = true;
      let that = this;
      videoElement.addEventListener("canplay", function () {
        setTimeout(() => {
          var canvas = document.createElement("canvas");
          canvas.width = 300;
          canvas.height = 200;
          canvas
            .getContext("2d")
            .drawImage(videoElement, 0, 0, canvas.width, canvas.height);
          var nameImg = new Date().getTime() + "_on.png";
          var url =
            "file/ism/" +
            window.sessionStorage.getItem("companyId") +
            "/" +
            nameImg;
          var firstFrame = canvas.toDataURL("image/png"); //第一帧图片url
          var mime = firstFrame.match(/:(.*?);/)[1];
          var image = that.dataURLtoFile(firstFrame, nameImg);
          console.log(url, mime, image);

          let fileData = new FormData();
          fileData.delete("uploadFiles");
          fileData.append("uploadFiles", image);
          post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
            .then((res) => {
              that.formViedo.pictureUrl = res.data;
              console.log(that.formViedo.pictureUrl);
              // this.formViedo.mediaUrl = res.data;
              // this.lookFileSrc2(this.formViedo.mediaUrl);
            })
            .catch(() => {});
          // var imgUpload = client.put(
          //   url,
          //   new Blob([image], { type: mime })
          //   // firstFrame
          // );
          // imgUpload
          //   .then((data) => {
          //     console.log("第一帧上传成功的截图封面", data);
          //     // console.log(data.url);
          //     this.pictureUrl = data.url;
          //   })
          //   .catch((error) => {
          //     console.log("error", error);
          //   });
        }, 1000);
      });
    },
    dataURLtoFile(dataUrl, fileName) {
      // 将base64转换为文件
      var arr = dataUrl.split(","),
        mimeType = arr[0].match(/:(.*?);/)[1],
        baseStr = atob(arr[1]),
        n = baseStr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = baseStr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mimeType });
    },
    //判断图片
    beforeAvatarUpload(file) {
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型

        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        console.log(FileExt);
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 100; //这里做文件大小限制
        //如果大于50M
        if (!isLt5M) {
          this.$showMessage("上传文件大小不能超过 100MB!");
          return false;
        }
        //如果文件类型不在允许上传的范围内
        if (this.filePhotoType.includes(FileExt)) {
          return true;
        } else {
          this.$message.error("上传文件格式不正确!");
          return false;
        }
      }
    },
    //判断视频
    beforeUpload2(file) {
      // console.log(file);
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型

        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        console.log(FileExt);
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 100; //这里做文件大小限制
        //如果大于50M
        if (!isLt5M) {
          this.$message.error("上传文件大小不能超过 100MB!");
          // this.$showMessage("上传文件大小不能超过 100MB!");
          return false;
        }
        //如果文件类型不在允许上传的范围内
        if (this.fileType.includes(FileExt)) {
          return true;
        } else {
          this.$message.error("上传文件格式不正确!");
          return false;
        }
      }
    },
    //删除文件
    handleRemove(i) {
      // console.log(file, fileList);
      this.fileList.splice(i, 1);
    },
    //超出文件个数的回调
    handleExceed() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！",
      });
      return;
    },
    //菜单切换
    selectMeau(index) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.activeMenu = index;
      // console.log(index);
      if (index == 1) {
        this.selectRecordList();
      } else if (index == 2) {
        this.selecteMediaInfoList();
      } else if (index == 3) {
        this.selectViedoInfoList();
      }
    },
    async lookFileSrc(src) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      this.fileList = [{ name: "文件", url: url.data }];
      this.videoList = [{ name: "文件", url: url.data }];
      this.imageUrl = url.data;
      // if (url) {
      //   window.open(url);
      // }
    },
    async lookFileSrc2(src) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      // console.log(url);
      let that = this;
      setTimeout(() => {
        // 在这里执行你想要的操作
        // console.log('定时器执行了');
        that.getVideoImage(url.data);
      }, 100);

      // if (url) {
      //   window.open(url);
      // }
    },
    formatStatus(status) {
      if (status == 1) {
        return "已保存";
      } else {
        // 处理其他状态的逻辑
        return "提交";
      }
    },
    //申报
    async selectRecordList() {
      let res = await selectRecordMsa(this.formInline);
      this.tableData = res.data.resultList;
      this.total = res.data.rowCount;
    },
    //图片
    async selecteMediaInfoList() {
      let res = await selecteMediaInfo(this.formInline2);
      res.data.resultList.forEach((item) => {
        item.uploadTime = item.uploadTime.split(" ")[0];
      });
      this.tableData2 = res.data.resultList;
      this.total2 = res.data.rowCount;
    },
    //视频
    async selectViedoInfoList() {
      let res = await selecteMediaInfo(this.formInline3);
      res.data.resultList.forEach((item) => {
        item.uploadTime = item.uploadTime.split(" ")[0];
      });
      this.tableData3 = res.data.resultList;
      this.total3 = res.data.rowCount;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    //申报分页
    handleSizeChange(size) {
      this.formInline.pageSize = size;
      // 调用后台接口或重新获取数据
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.selectRecordList();
    },
    handleCurrentChange(val) {
      this.formInline.pageNo = val;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      this.selectRecordList();
    },
    //图片分页
    handleSizeChange2(size) {
      this.formInline2.pageSize = size;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      this.selecteMediaInfoList();
    },
    handleCurrentChange2(val) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.formInline2.pageNo = val;
      // 调用后台接口或重新获取数据
      this.selecteMediaInfoList();
    },
    //视频分页
    handleSizeChange3(size) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.formInline3.pageSize = size;
      // 调用后台接口或重新获取数据
      this.selectViedoInfoList();
    },
    handleCurrentChange3(val) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.formInline3.pageNo = val;
      // 调用后台接口或重新获取数据
      this.selectViedoInfoList();
    },
    gotoHome() {
      window.scrollTo({
        top: 0,
      });
      this.$router.push("/home");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.gray-td {
  background: #f0f1f2;
  width: 21.1429rem;
  text-align: right;
}
.flex-td {
  display: flex;
  line-height: 2.8571rem;
}
.td-check {
  width: 25.7143rem;
}
.avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    color: #3370ff;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 2rem;
  color: #8c939d;
  width: 25rem;
  height: 13.8571rem;
  line-height: 13.8571rem !important;
  text-align: center;
}
.avatar {
  width: 25rem;
  height: 13.8571rem;
  display: block;
}
</style>
